import { Seo } from '../../lib/seo';
import { PageHero } from '../../components/PageHero';
import { FormContact } from '../../components/FormContact';



export function ContactPage() {
  return (
    <>
      <Seo
        title="Contato"
        description="Entre em contato com a A3GS Tec para solicitar orçamento e conversar sobre tecnologia."
        path="/contato"
      />

      <PageHero
        eyebrow="CONTATO"
        title="Vamos conversar sobre o seu projeto."
        description="Envie os detalhes e registre sua solicitação diretamente no sistema."
      />

      <section className="section">
        <div className="container contact-grid">
          <FormContact />

          <aside className="contact-aside">
            <span className="section-tag">ATENDIMENTO</span>
            <h2>Uma estrutura pronta para receber seu projeto.</h2>
            <p>
              O formulário grava a mensagem no Cloudflare D1.
              Depois, o painel administrativo pode organizar os contatos recebidos.
            </p>
            <p className="contact-note">
              Use o formulário para registrar a solicitação.
              Os dados ficam disponíveis no painel administrativo.
            </p>
          </aside>
        </div>
      </section>
    </>
  );
}